import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
function ModalBody(_ref) {
  var className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsx("div", {
    className: classNames('modal-body', className),
    "data-testid": dataTestId,
    style: style,
    children: children
  });
}
export default ModalBody;
//# sourceMappingURL=ModalBody.js.map